import React from 'react'

export default function NoPage() {
  return (
    <div className='h-screen dark:text-white text-3xl flex justify-center items-center'>
         page not found!
    </div>
  )
}
